module.exports = "<button class=\"remove\" mdl-button (click)=\"onRemove()\">\r\n    <mdl-icon>delete</mdl-icon>\r\n</button>"